import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.446.686C8.601.935 7.083 2.351 6.658 4.164a4.425 4.425 0 0 0 .26 2.81L.733 13.16a.395.395 0 0 0-.116.28v1.81c0 .218.177.394.395.394h1.81a.394.394 0 0 0 .28-.115l.952-.953a.395.395 0 0 0 .116-.28v-1.02h1.02a.394.394 0 0 0 .28-.116l.558-.558a.395.395 0 0 0 .116-.279v-1.02h1.02a.394.394 0 0 0 .28-.116l1.842-1.843c.836.362 1.792.5 2.81.26 1.814-.426 3.23-1.943 3.479-3.789A4.543 4.543 0 0 0 10.447.686Zm2.013 4.3a1.184 1.184 0 1 1 0-2.369 1.184 1.184 0 0 1 0 2.369Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;
